<script>
    import {onDestroy, onMount} from 'svelte';
    import {fade} from 'svelte/transition';
    import {PRConnect} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
    import { planStore } from "./store/plan-store";
    import { _ } from 'svelte-i18n';
    import moment from 'moment-timezone';
    import { Section, Button, Badge, Switch, Select, Dialog } from '../lib/ui';

    let authType;
    let emailId;
    let phoneNo;
    let notiFlag;
    let withdrawFlag;
    let licenseFlag;
    let licenseName;
    let connectDosi;
    let nftList = [];
    let paymentList = [];
    let subscriptionInfo;
    let paymentMethodInfo;
    let contractId;
    let tokenType;
    let tokenIndex;
    let isPaymentMethodChangeCompleteFlag;

    const withdrawReasonList = [
        { value: "서비스 이용의 어려움", label:$_('project.default.47_7')},
        { value: "서비스 장애와 오류 발생", label:$_('project.default.47_8')},
        { value: "서비스 제공 기능 불만", label:$_('project.default.47_9')},
        { value: "서비스 가격 불만", label:$_('project.default.47_10')},
        { value: "더 이상의 서비스 이용 의사가 없음", label:$_('project.default.47_11')},
        { value: "탈퇴 후 신규 가입을 위함", label:$_('project.default.47_12')},
        { value: "기타", label:$_('project.default.47_13')}
    ];

    let withdrawReason = "";
    let withdrawAgreeCheckFlag = false;
    let doWithdrawFlag = false;
    let planStoreSubsc;
    export let authSelectFlag;

    // 국내 결제 스크립트 동적 로드(중복 로드 방지). clientKey/scriptUrl은 결제서비스가 내려준다.
    const loadedScripts = {};
    const loadScript = (src) =>
        new Promise((resolve, reject) => {
            if (loadedScripts[src] || typeof PaypleCpayAuthCheck !== 'undefined') {
                resolve();
                return;
            }
            const s = document.createElement('script');
            s.src = src;
            s.onload = () => { loadedScripts[src] = true; resolve(); };
            s.onerror = reject;
            document.head.appendChild(s);
        });

    onMount(() => {
        planStoreSubsc = planStore.subscribe(message => {
            authType = message?.authType;
        });
        accountInit();
    });

    onDestroy(() => {
        planStoreSubsc();
    });

    const accountInit = () => {
        PRConnect.send("/api/User/getUserById", {}, data => {
            if (data.header.status === "success") {
                emailId = data.result.userInfo.emailId;
                phoneNo = data.result.userInfo.phoneNo;
                notiFlag = data.result.userInfo.notiFlag;
                authSelectFlag = data.result.userInfo.authSelectFlag == 'N' ? true : false;
                nftList = data.result.nftList;
                connectDosi = data.result.connectDosi;
                paymentList = data.result.paymentList;
                subscriptionInfo = data.result.subscriptionInfo;
                paymentMethodInfo = data.result.paymentMethodInfo;
            }
        });
    }

    const toggleNoti = () => {
        notiFlag = notiFlag === "Y" ? "N" : "Y";
        PRConnect.send("/api/User/modifyUserById", {notiFlag}, data => {
            if (data.header.status === "success") {
                console.log("notiflag update");
            }
        });
    }

    const clickWithdraw = () => {
        if (!withdrawAgreeCheckFlag) {
            doWithdrawFlag = true;
            return;
        }
        PRConnect.send("/api/User/deleteUserById", {}, data => {
            if (data.header.status === "success") {
                console.log("user delete");
                navigateTo("/login");
            }
        });
    }

    const clickChangePlan = () => {
        planStore.setAuthSelectFlag(true);
    }

    const clickNftUse = (nft) => {
        licenseFlag = true;
        licenseName = nft.description;
        contractId = nft.identifier.contractId;
        tokenType = nft.identifier.tokenType;
        tokenIndex = nft.identifier.tokenIndex;
    }

    const doNftUse = () => {
        licenseFlag = false;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        PRConnect.send("/api/User/useNft", {contractId, tokenType, tokenIndex, timeZone}, data => {
            if (data.header.status === "success") {
                accountInit();
                planStore.init();
            }
        });
    }

    const formatCurrency = (value, currency) => {
        const numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
            return 'Invalid number';
        }

        let options = {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'symbol'
        };

        if (currency === 'KRW') {
            options.minimumFractionDigits = 0;
            options.maximumFractionDigits = 0;
            const formattedNumber = new Intl.NumberFormat('ko-KR', options).format(numberValue);
            return formattedNumber + ' 원';
        } else {
            return new Intl.NumberFormat('en-US', options).format(numberValue);
        }
    }

    const clickPaymentReceipt = (receiptUrl) => {
        window.open(receiptUrl);
    }

    const clickPaymentMethodChange = () => {
        // 결제서비스에 빌링키 재발급(AUTH) 세션 요청 → scriptUrl 로드 + authParams로 결제창 호출
        PRConnect.send("/api/Payment/createBillingAuthSession", {}, async data => {
            if (data.header.status === "success") {
                const { paypleAuthParams, payple, payer } = data.result;
                await loadScript(payple.scriptUrl);
                PaypleCpayAuthCheck({
                    ...paypleAuthParams,          // clientKey·PCD_PAY_WORK(AUTH)·PCD_PAYER_NO 등
                    PCD_PAYER_NAME: payer.name,   // payer PII는 le868에서만 채움
                    PCD_PAYER_EMAIL: payer.email,
                    PCD_PAYER_HP: payer.hp,
                    PCD_PAY_URL: payer.returnUrl,
                    callbackFunction: handlePaymentMethodCallback,
                });
            }
        });
    }
    const handlePaymentMethodCallback = (result) => {
        if (result["PCD_PAY_RST"] === "success") {
            // SPA 콜백의 새 빌링키(PCD_PAYER_ID)+카드정보를 결제서비스로 전달해 구독에 반영
            PRConnect.send("/api/Payment/modifyPaymentMethod", {
                billingKey: result["PCD_PAYER_ID"],
                cardName: result["PCD_PAY_CARDNAME"],
                cardNumber: result["PCD_PAY_CARDNUM"],
            }, data => {
                if (data.header.status === "success") {
                    isPaymentMethodChangeCompleteFlag = true;
                    paymentMethodInfo = data.result;
                }
            });
        } else {
            // 결제 실패 일 경우 실패 원인 기록 API 호출
        }
    }
    const clickPaymentMethodChangeCompletePopupOff = () => {
        isPaymentMethodChangeCompleteFlag = false;
    }

    const fmtDate = (d) => moment.utc(d).local().format("YYYY-MM-DD");
    const fmtRange = (s, e) => `${fmtDate(s)} - ${fmtDate(e)}`;

    // Badge 컴포넌트는 기본 variant 색을 class로 덮어쓸 수 없고(cn=단순 결합, tailwind-merge X)
    // style도 전달 안 됨 → 커스텀 색 칩은 이 base 문자열로 직접 span을 그린다(Badge와 동일한 모양).
    const chipBase = "tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium";
</script>

{#if emailId}
<div class="tw-min-h-screen tw-bg-background tw-font-sans tw-text-foreground" in:fade>
    <div class="tw-mx-auto tw-w-full tw-max-w-4xl tw-px-4 tw-py-10 sm:tw-px-6">

        <!-- 페이지 헤더 -->
        <header class="tw-mb-8">
            <div class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-primary">
                {$_('project.default.36_ACCOUNT')}
            </div>
            <h1 class="tw-mt-1.5 tw-text-2xl tw-font-bold tw-text-foreground">{$_('project.default.37')}</h1>
            <p class="tw-mt-1 tw-text-sm tw-text-muted-foreground">{$_('project.default.38')}</p>
        </header>

        <!-- 계정 정보 -->
        <Section title={$_('project.default.39')} class="tw-mb-5">
            <div class="tw-divide-y tw-divide-border">
                <!-- 멤버십 -->
                <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-py-4 first:tw-pt-0">
                    <div class="tw-min-w-0">
                        <div class="tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.47_32')}</div>
                        {#if subscriptionInfo?.nextPaymentDate}
                            <div class="tw-mt-1 tw-text-xs tw-text-muted-foreground">
                                {subscriptionInfo.cancelAtPeriodEnd ? $_('project.default.50_22') : $_('project.default.50_1')} · {fmtDate(subscriptionInfo.nextPaymentDate)}
                            </div>
                        {/if}
                    </div>
                    <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-1.5">
                        {#if authType}<Badge>{authType}</Badge>{/if}
                        {#if connectDosi}<span class="{chipBase} tw-bg-foreground tw-text-background">DOSI</span>{/if}
                    </div>
                </div>

                <!-- 휴대폰 번호 -->
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4">
                    <div class="tw-text-sm tw-font-medium tw-text-muted-foreground">{$_('project.default.40')}</div>
                    <div class="tw-text-sm tw-font-medium tw-text-foreground">{phoneNo || "-"}</div>
                </div>

                <!-- 이메일 -->
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4">
                    <div class="tw-text-sm tw-font-medium tw-text-muted-foreground">{$_('project.default.41')}</div>
                    <div class="tw-truncate tw-text-sm tw-font-medium tw-text-foreground">{emailId || "-"}</div>
                </div>

                <!-- 알림 설정 -->
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4">
                    <div class="tw-min-w-0">
                        <div class="tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.42')}</div>
                        <div class="tw-mt-0.5 tw-text-xs tw-text-muted-foreground">{$_('project.default.43')}</div>
                    </div>
                    <Switch checked={notiFlag === "Y"} on:click={toggleNoti} aria-label={$_('project.default.42')} />
                </div>
            </div>

            <!-- 계정 관리 액션 -->
            <div class="tw-mt-2 tw-border-t tw-border-border tw-pt-5">
                <div class="tw-mb-3 tw-text-xs tw-font-semibold tw-text-muted-foreground">{$_('project.default.47_33')}</div>
                <div class="tw-flex tw-flex-wrap tw-gap-2">
                    <Button on:click={clickChangePlan}>{$_('project.default.44')}</Button>
                    <Button variant="outline" on:click={() => navigateTo("/find-password")}>{$_('project.default.45')}</Button>
                </div>
                <button
                    type="button"
                    class="tw-mt-4 tw-cursor-pointer tw-bg-transparent tw-text-xs tw-text-muted-foreground hover:tw-text-destructive"
                    on:click={() => withdrawFlag = true}
                >
                    {$_('project.default.46_0')} <span class="tw-font-semibold tw-underline tw-underline-offset-2">{$_('project.default.46')}</span>
                </button>
            </div>
        </Section>

        <!-- 결제 수단 -->
        {#if paymentMethodInfo}
        <Section title={$_('project.default.50_2')} class="tw-mb-5">
            <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
                <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
                    <div class="tw-flex tw-h-10 tw-w-14 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-border tw-bg-muted/40 tw-text-muted-foreground">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>
                    </div>
                    <div class="tw-min-w-0">
                        <div class="tw-text-xs tw-text-muted-foreground">{$_('project.default.50_3')}</div>
                        <div class="tw-truncate tw-text-sm tw-font-semibold tw-text-foreground">{paymentMethodInfo.name} {paymentMethodInfo.cardNumber}</div>
                    </div>
                </div>
                <Button variant="outline" size="sm" on:click={clickPaymentMethodChange}>{$_('project.default.50_4')}</Button>
            </div>
        </Section>
        {/if}

        <!-- DOSI 멤버십 보유내역 -->
        {#if connectDosi}
        <Section title={$_('project.default.47_27')} description={nftList.length > 0 ? $_('project.default.47_28') : $_('project.default.47_29')} class="tw-mb-5">
            {#if nftList.length > 0}
                <div class="tw-overflow-x-auto">
                    <table class="tw-w-full tw-min-w-[560px] tw-border-collapse tw-text-left tw-text-sm">
                        <thead>
                            <tr class="tw-border-b tw-border-border tw-text-xs tw-font-medium tw-text-muted-foreground">
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.47_37')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.47_38')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.47_39')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-text-right tw-font-medium">{$_('project.default.47_40')}</th>
                            </tr>
                        </thead>
                        <tbody class="tw-divide-y tw-divide-border">
                            {#each nftList as nft}
                                <tr>
                                    <td class="tw-px-3 tw-py-3 tw-font-medium tw-text-foreground">{nft['description']}</td>
                                    <td class="tw-px-3 tw-py-3 tw-text-muted-foreground">{nft['logDate'] ? fmtDate(nft['logDate']) : '-'}</td>
                                    <td class="tw-px-3 tw-py-3 tw-text-muted-foreground">{nft['startDate'] && nft['endDate'] ? fmtRange(nft['startDate'], nft['endDate']) : '-'}</td>
                                    <td class="tw-px-3 tw-py-3 tw-text-right">
                                        {#if nft['logDate']}
                                            <Badge variant="optional">{$_('project.default.47_41')}</Badge>
                                        {:else}
                                            <Button size="sm" on:click={() => clickNftUse(nft)}>사용하기</Button>
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            {:else}
                <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-lg tw-border tw-border-dashed tw-border-border tw-bg-muted/30 tw-px-6 tw-py-12 tw-text-center">
                    <img src="/static/images/dosi-logo_2.svg" alt="DOSI" class="tw-h-8 tw-opacity-80" />
                    <div class="tw-text-sm tw-text-muted-foreground">{$_('project.default.47_30')}</div>
                    <a href="https://www.dosi.world/brands/91" target="_blank" rel="noreferrer" class="tw-no-underline">
                        <Button>{$_('project.default.47_31')}</Button>
                    </a>
                </div>
            {/if}
        </Section>
        {/if}

        <!-- 결제 내역 -->
        <Section title={$_('project.default.50_5')}>
            {#if paymentList.length > 0}
                <div class="tw-overflow-x-auto">
                    <table class="tw-w-full tw-min-w-[720px] tw-border-collapse tw-text-left tw-text-sm">
                        <thead>
                            <tr class="tw-border-b tw-border-border tw-text-xs tw-font-medium tw-text-muted-foreground">
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.50_6')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.50_7')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.50_8')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.50_9')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-text-right tw-font-medium">{$_('project.default.50_10')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-font-medium">{$_('project.default.50_11')}</th>
                                <th class="tw-px-3 tw-py-2.5 tw-text-right tw-font-medium">{$_('project.default.50_12')}</th>
                            </tr>
                        </thead>
                        <tbody class="tw-divide-y tw-divide-border">
                            {#each paymentList as payment}
                                <tr>
                                    <td class="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-muted-foreground">{fmtDate(payment['paymentDate'])}</td>
                                    <td class="tw-px-3 tw-py-3 tw-font-medium tw-text-foreground">{payment.plan}</td>
                                    <td class="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-muted-foreground">
                                        {payment['startDate'] && payment['endDate'] ? fmtRange(payment['startDate'], payment['endDate']) : '-'}
                                    </td>
                                    <td class="tw-px-3 tw-py-3">
                                        {#if payment['type'] === "REFUND"}
                                            <Badge variant="required">{$_('project.default.50_21')}</Badge>
                                        {:else if payment['status'] === "COMPLETED"}
                                            <span class="{chipBase} tw-bg-emerald-500/10 tw-text-emerald-600">{$_('project.default.50_13')}</span>
                                        {:else}
                                            <Badge variant="optional">{$_('project.default.50_14')}</Badge>
                                        {/if}
                                    </td>
                                    <td class="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-right tw-font-semibold tw-text-foreground">
                                        {formatCurrency(payment['amount'], payment['currency'])}
                                    </td>
                                    <td class="tw-px-3 tw-py-3 tw-text-muted-foreground">
                                        <div>{payment.methodType === "card" ? $_('project.default.50_15') : $_('project.default.50_16')}</div>
                                        <div class="tw-text-xs">{payment.name} {payment.cardNumber}</div>
                                    </td>
                                    <td class="tw-px-3 tw-py-3 tw-text-right">
                                        <Button variant="outline" size="sm" on:click={() => clickPaymentReceipt(payment.cardReceipt)}>{$_('project.default.50_17')}</Button>
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            {:else}
                <div class="tw-py-10 tw-text-center tw-text-sm tw-text-muted-foreground">—</div>
            {/if}
        </Section>

    </div>
</div>
{/if}

<!-- 회원 탈퇴 팝업 -->
<Dialog open={withdrawFlag} title={$_('project.default.47')} on:close={() => withdrawFlag = false} class="tw-max-w-lg">
    <div class="tw-space-y-5">
        <!-- 유의사항 -->
        <div>
            <div class="tw-mb-2 tw-text-sm tw-font-semibold tw-text-foreground">{$_('project.default.47_0')}</div>
            <ul class="tw-list-disc tw-space-y-1.5 tw-rounded-lg tw-bg-muted/50 tw-py-4 tw-pl-9 tw-pr-4 tw-text-xs tw-text-muted-foreground">
                <li>{$_('project.default.47_1')}</li>
                <li>{$_('project.default.47_2')}</li>
                <li>{$_('project.default.47_3')}</li>
                <li>{$_('project.default.47_4')}</li>
                <li>{$_('project.default.47_5')}</li>
            </ul>
        </div>

        <!-- 탈퇴 사유 -->
        <div>
            <Select bind:value={withdrawReason}>
                <option value="" disabled>{$_('project.default.47_6')}</option>
                {#each withdrawReasonList as reason}
                    <option value={reason.value}>{reason.label}</option>
                {/each}
            </Select>
        </div>

        <!-- 동의 -->
        <div>
            <div class="tw-mb-2 tw-flex tw-items-center tw-gap-2">
                <span class="tw-text-sm tw-font-semibold tw-text-foreground">{$_('project.default.47_14')}</span>
                {#if !withdrawAgreeCheckFlag && doWithdrawFlag}
                    <span class="tw-text-xs tw-text-destructive">{$_('project.default.47_14_0')}</span>
                {/if}
            </div>
            <label class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2">
                <input type="checkbox" bind:checked={withdrawAgreeCheckFlag} class="tw-h-4 tw-w-4 tw-rounded" style="accent-color: hsl(var(--sb-primary))" />
                <span class="tw-text-sm tw-text-foreground">{$_('project.default.47_14_1')}</span>
            </label>
        </div>
    </div>
    <svelte:fragment slot="footer">
        <Button variant="outline" on:click={() => withdrawFlag = false}>{$_('project.default.47_14_2')}</Button>
        <Button variant="destructive" on:click={clickWithdraw}>{$_('project.default.47_14_3')}</Button>
    </svelte:fragment>
</Dialog>

<!-- DOSI NFT 사용 팝업 -->
<Dialog open={licenseFlag} on:close={() => licenseFlag = false} class="tw-max-w-sm">
    <svelte:fragment slot="header">
        <img src="/static/images/dosi-logo.png" loading="lazy" alt="DOSI" class="tw-h-6" />
    </svelte:fragment>
    <p class="tw-text-center tw-text-sm tw-leading-relaxed tw-text-foreground">
        {$_('project.default.47_15')} <strong class="tw-font-semibold">{licenseName}</strong>{$_('project.default.47_16')}
    </p>
    <svelte:fragment slot="footer">
        <Button variant="outline" on:click={() => licenseFlag = false}>{$_('project.default.47_17')}</Button>
        <Button on:click={doNftUse}>{$_('project.default.47_18')}</Button>
    </svelte:fragment>
</Dialog>

<!-- 결제수단 변경 완료 팝업 -->
<Dialog open={isPaymentMethodChangeCompleteFlag} title={$_('project.default.50_18')} on:close={clickPaymentMethodChangeCompletePopupOff} class="tw-max-w-sm">
    <p class="tw-text-center tw-text-sm tw-text-foreground">{$_('project.default.50_19')}</p>
    <svelte:fragment slot="footer">
        <Button class="tw-w-full" on:click={clickPaymentMethodChangeCompletePopupOff}>{$_('project.default.50_20')}</Button>
    </svelte:fragment>
</Dialog>
